var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0982422 9.23227L6.77416 15.9027C6.83691 15.9654 6.92165 16 7.0104 16C7.09914 16 7.18391 15.9647 7.24663 15.902L13.9026 9.23227C13.998 9.13696 14.026 8.9937 13.9746 8.86905C13.9226 8.74444 13.8011 8.66378 13.6663 8.66378L9.99604 8.66378L9.99604 0.333231C9.99604 0.149293 9.84655 3.63106e-07 9.66236 3.79208e-07L4.32374 8.45926e-07C4.13955 8.62027e-07 3.99006 0.149294 3.99006 0.333232L3.99006 8.66381L0.333787 8.66381C0.198997 8.66381 0.0775321 8.74513 0.0254806 8.86974C-0.0265709 8.99435 0.0028032 9.13696 0.0982422 9.23227Z",
    fill: "#EC5C52"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRed);
export default __webpack_public_path__ + "static/media/arrowRed.27a9cace.svg";
export { ForwardRef as ReactComponent };